import { render, staticRenderFns } from "./Item1.vue?vue&type=template&id=71181630&scoped=true"
import script from "./Item1.vue?vue&type=script&lang=js"
export * from "./Item1.vue?vue&type=script&lang=js"
import style0 from "./Item1.vue?vue&type=style&index=0&id=71181630&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71181630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71181630')) {
      api.createRecord('71181630', component.options)
    } else {
      api.reload('71181630', component.options)
    }
    module.hot.accept("./Item1.vue?vue&type=template&id=71181630&scoped=true", function () {
      api.rerender('71181630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Item1.vue"
export default component.exports